import '../src/base';
import '~/app/assets/javascripts/application/sitewide';
import '~/app/assets/javascripts/application/fies/main';
import '~/app/assets/javascripts/application/shared/manual_tracking';
